import { ArrowDownward, ArrowUpward } from "@material-ui/icons";
import moment from "moment";
import { initialFilters, periods } from "../../financeiro/constants";

export const contractColumns = [
  {
    label: "Empresa",
    id: "company",
    style: {
      whiteSpace: "nowrap",
    },
  },
  {
    label: "Razão Social",
    id: "serviceContractDescription",
    sorting: "disabled",
    style: {
      whiteSpace: "nowrap",
    },
    format: (item) => item ?? "Sem razão social",
  },
  {
    label: "Id Contrato",
    id: "serviceContractId",
  },
  {
    label: "Número",
    id: "serviceContractNumber",
    sorting: "disabled",
  },

  {
    label: "Data Emissão",
    id: "serviceContractEmissionDate",
    minWidth: 125,
    format: (item) => moment(item).format("DD/MM/YYYY"),
  },
  { label: "Status", id: "serviceContractStatus" },
  {
    label: "Modalidade",
    id: "serviceContractModality",
  },
  {
    label: "Valor Contrato ( R$ )",
    id: "serviceContractAmount",
    minWidth: 132,
    align: "right",
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
];

export const receivablesColumns = [
  {
    label: "IDCR",
    id: "receivableId",
    cellColor: "#E2F1FF",
  },
  {
    label: "Documento",
    id: "receivableDocument",
    cellColor: "#E2F1FF",
  },
  {
    label: "Data Vencimento",
    id: "receivableExpirationDate",
    cellColor: "#E2F1FF",
    minWidth: 125,
    sorting: "disabled",
    format: (item) => moment(item).format("DD/MM/YYYY"),
  },
  {
    label: "Situação",
    id: "receivableStatus",
    cellColor: "#E2F1FF",
  },
  {
    label: "Valor Docto (R$)",
    id: "receivableDocumentAmount",
    cellColor: "#E2F1FF",
    minWidth: 132,
    align: "right",
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
  {
    label: "Acrescimos (R$)",
    id: "receivableIncrease",
    cellColor: "#E2F1FF",
    minWidth: 132,
    align: "right",
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
  {
    label: "Descontos (R$)",
    id: "receivableDiscount",
    cellColor: "#E2F1FF",
    minWidth: 132,
    align: "right",
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
  {
    label: "Valor Original  (R$)",
    id: "receivableOriginalAmount",
    cellColor: "#E2F1FF",
    minWidth: 132,
    align: "right",
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
  {
    label: "Conta Bancária",
    id: "receivableBankAccount",
    cellColor: "#E2F1FF",
  },
];

export const taxNotesColumns = [
  {
    label: "Nº NFSe",
    id: "serviceTaxNoteNumber",
    format: (item) => (!item ? " - " : item),
    sorting: "disabled",
  },
  {
    label: "Nº RPS",
    id: "serviceTaxNoteRpsNumber",
    format: (item) => (!item ? " - " : item),
  },
  {
    label: "Data Emissão",
    id: "serviceTaxNoteEmissionDate",
    minWidth: 125,
    format: (item) => (!item ? " - " : moment(item).format("DD/MM/YYYY")),
  },

  {
    label: "Valor NFSe (R$)",
    id: "serviceTaxNoteTotalAmount",
    minWidth: 132,
    align: "right",
    format: (item) => {
      return !item
        ? " - "
        : `${item.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 5,
          })}`;
    },
  },
];

export const invoiceMirrorSituations = [
  { desc: "Abertos", id: "open", checked: true },
  { desc: "Vencidos", id: "expired", checked: true },
  { desc: "Recebidos", id: "received", checked: true },
];

const initialQuickSituations = invoiceMirrorSituations
  .map((situation) => situation.id)
  .join(",");

export const invoiceMirrorDateType = {
  "Contrato - Emissão": "serviceContractEmissionDate",
  "Contas a Receber - Vencimento": "accountReceivableExpirationDate",
  "Contas a Receber - Pagamento": "accountReceivableReceiptDate",
  "NFSe - Emissão": "serviceTaxNoteEmissionDate",
};

export const invoiceMirrorContractStatus = {
  Todos: null,
  Ativo: "active",
  Cancelado: "canceled",
  Suspenso: "suspended",
};

export const invoiceMirrorContractModality = {
  Todos: null,
  Recorrente: "recurrent",
  Avulso: "detached",
};

export const xlsxGroupEmptyDescription = {
  serviceContractCustomerId: "Cliente sem razão cadastrada",
  serviceContractModality: "Sem modalidade",
  serviceContractStatus: "Sem tipo de serviço",
  receivableStatus: "Sem situação financeira",
};

export const invoiceMirrorGroupment = {
  "Sem agrupamento": null,
  Cliente: "serviceContractCustomerId",
  "Modalidade Contrato": "serviceContractModality",
  "Status Contrato": "serviceContractStatus",
  "Situação Financeiro": "receivableStatus",
};

export const sortIcon = {
  disabled: <ArrowUpward fontSize="inherit" color="disabled" />,
  asc: <ArrowUpward fontSize="inherit" color="primary" />,
  desc: <ArrowDownward fontSize="inherit" color="primary" />,
};

export const initialTaxFilter = {
  multicompany: initialFilters.multicompany,
  period: periods["Este mês"],
  contractModality: invoiceMirrorContractModality.Todos,
  dateFilter: invoiceMirrorDateType["Contas a Receber - Vencimento"],
  contractStatus: invoiceMirrorContractStatus.Ativo,
  accountReceivableQuickStatus: initialQuickSituations,
  group: invoiceMirrorGroupment["Sem agrupamento"],
};
